import mqtt from "mqtt";
import {parseTime} from './miniUtil.js'

class mqttHandle {
    constructor(subscribe,clientId) {
        this.connect = {
			// 'mqtt.sxjzkeji.com'
			// /mqttest
			host:process.env.VUE_APP_IMSP_MQTT_HOST,
            port:"8886",
            endpoint:process.env.VUE_APP_IMSP_MQTT_ENDPOINT,
            options:{
              username: process.env.VUE_APP_IMSP_MQTT_USERNAME,
              password: process.env.VUE_APP_IMSP_MQTT_PASSWORD,
			  // username: 'client',
			  // password: 'Y2xpZW50',
              cleanSession: true,
              keepAlive: 60,
              clientId: clientId,
              connectTimeout: 4000
            }
        }

        this.subscription = {
            topic: subscribe,  //需要传入数组的包含订阅的名称
            qos: 2,
        }
        this.mqttClient = null;
    }
    /**
     * 创建链接
     * @returns client
     */
    createConnect() {

        //配置链接
        const { host, port, endpoint, options } = this.connect;
        const connectUrl = `wss://${this.connect.host}:${this.connect.port}${this.connect.endpoint}`;
		
        try {
            this._client = mqtt.connect(connectUrl, options);

        } catch (error) {
            console.log("mqtt.connect error", error);
        }
        this._client.on("connect", (e) => {
            console.log("Connection succeeded!",parseTime(new Date(),'{y}{m}{d}-{h}:{i}:{s}'));
            console.log("成功连接服务器:", e);
        });
        this._client.on('reconnect', (error) => {
            console.log('正在重连', error)
        })
        this._client.on("error", (error) => {
            console.log("Connection failed"+parseTime(new Date(),'{y}{m}{d}-{h}:{i}:{s}'), error);
        });

        //配置topic
        const { topic, qos } = this.subscription;
        this._client.subscribe(topic, { qos: qos }, (error, res) => {
            if (error) {
                console.log("Subscribe to topics error", error);
                return;
            }
            this.subscribeSuccess = true;
            console.log("Subscribe to topics res", res[0].qos, res[0].topic);
        });
        this.mqttClient = this._client;
        return this.mqttClient;
    }
}

export default mqttHandle;
